import {
  PRODUCT_CLASS_LIST_ALL,
  PRODUCT_CLASS_LISTED_ALL,
  PRODUCT_CLASS_VIEW,
  PRODUCT_CLASS_VIEW_LOADED,
  PRODUCT_CLASS_SEARCH,
  PRODUCT_CLASS_UNLOAD
} from './action_types';

export const findAll = () => ({ type: PRODUCT_CLASS_LIST_ALL, payload: {} });
export const foundAll = payload => ({ type: PRODUCT_CLASS_LISTED_ALL, payload });
export const findById = payload => ({ type: PRODUCT_CLASS_VIEW, payload });
export const foundById = payload => ({ type: PRODUCT_CLASS_VIEW_LOADED, payload });
export const search = payload => ({ type: PRODUCT_CLASS_SEARCH, payload });
export const unload = () => ({ type: PRODUCT_CLASS_UNLOAD, payload: {} });
